import { render, staticRenderFns } from "./ExerciseInstructions.vue?vue&type=template&id=db9bd072&scoped=true&"
import script from "./ExerciseInstructions.vue?vue&type=script&lang=js&"
export * from "./ExerciseInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseInstructions.vue?vue&type=style&index=0&id=db9bd072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9bd072",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
